<template>
  <div>
    <h3>Current Session:</h3>
    <pre>{{ session }}</pre>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'Session',
  computed: {
    ...mapState(['session']),
  },
};
</script>

<style scoped>
/* Add your styles here */
</style>